import styled, { css } from 'styled-components'

export const Wrapper = styled('div')(
  () => css`
    padding: 0 0.8rem;
  `
)
